import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CorrespondenceCompanyDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.css'],
})
export class CompanyViewComponent implements OnInit {
  @Input() companies: CorrespondenceCompanyDto[];
  companiesForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<CorrespondenceCompanyDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  status: boolean;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.companiesForm = this.fb.group({ Companies: this.fb.array([]) });
    this.setCompany();
  }

  // method to display countries
  setCompany() {
    const control = this.companiesForm.controls.Companies as FormArray;
    this.companies.forEach((e) => {
      control.push(
        this.fb.group({
          CorrespondenceCompanyName: e.CorrespondenceCompanyName,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.companiesForm.controls.Companies as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to add Country
  addCompany() {
    const control = this.companiesForm.controls.Companies as FormArray;
    control.insert(
      0,
      this.fb.group({
        CorrespondenceCompanyName: ['', Validators.required],
        id: null,
      })
    );
  }

  // method to delete country from arrary list
  deleteCompany(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.companiesForm.controls.Companies as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'company';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('company');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
